import { useMutation } from '@tanstack/react-query';

import login from '../../api/mutations/login';

const useLogin = () => {
  const { mutateAsync: loginUser, isPending } = useMutation({
    mutationKey: ['login'],
    mutationFn: (data: { email: string; password: string }) => login(data),
  });

  return { loginUser, isPending };
};

export default useLogin;
